// The purpose of this file is for handling the
// registration of Font Awesome icons
import { Library } from '@fortawesome/fontawesome-svg-core';
import { faFileUser as faFileUserSolid } from '@fortawesome/pro-solid-svg-icons/faFileUser';
import { faFileUser as faFileUserRegular } from '@fortawesome/pro-regular-svg-icons/faFileUser';
import { faFileUser as faFileUserLight } from '@fortawesome/pro-light-svg-icons/faFileUser';
import { faFileArrowUp as faFileArrowUpSolid } from '@fortawesome/pro-solid-svg-icons/faFileArrowUp';
import { faPen as faPenSolid } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faPen as faPenLight } from '@fortawesome/pro-light-svg-icons/faPen';
import { faTrash as faTrashSolid } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTrashCan as faTrashCanLight } from '@fortawesome/pro-light-svg-icons/faTrashCan';
import { faTimes as faTimesSolid } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faSearch as faSearchSolid } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCheckCircle as faCheckCircleLight } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faTimesCircle as faTimesCircleSolid } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faMinusCircle as faMinusCircleSolid } from '@fortawesome/pro-solid-svg-icons/faMinusCircle';
import { faMapMarkerAlt as faMapMarkerAltSolid } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { faClipboardCheck as faClipboardCheckSolid } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faFile as faFileSolid } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faFilter as faFilterSolid } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faThList as faThListSolid } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTh as faThSolid } from '@fortawesome/pro-solid-svg-icons/faTh';
import { faBars as faBarsSolid } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faGraduationCap as faGraduationCapSolid } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faEnvelope as faEnvelopeSolid } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faCalendar as faCalendarSolid } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCalendar as faCalendarLight } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faUserCircle as faUserCircleSolid } from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import { faUserCheck as faUserCheckSolid } from '@fortawesome/pro-solid-svg-icons/faUserCheck';
import { faUserEdit as faUserEditSolid } from '@fortawesome/pro-solid-svg-icons/faUserEdit';
import { faUserGraduate as faUserGraduateSolid } from '@fortawesome/pro-solid-svg-icons/faUserGraduate';
import { faChevronDown as faChevronDownSolid } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp as faChevronUpSolid } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronLeft as faChevronLeftSolid } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as faChevronRightSolid } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCaretDown as faCaretDownSolid } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp as faCaretUpSolid } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretLeft as faCaretLeftSolid } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faCaretRight as faCaretRightSolid } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faExclamationCircle as faExclamationCircleSolid } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationCircle as faExclamationCircleLight } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { faSadTear as faSadTearSolid } from '@fortawesome/pro-solid-svg-icons/faSadTear';
import { faClock as faClockSolid } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faSave as faSaveSolid } from '@fortawesome/pro-solid-svg-icons/faSave';
import { faBriefcase as faBriefcaseSolid } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faBullhorn as faBullhornSolid } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCoffee as faCoffeeSolid } from '@fortawesome/pro-solid-svg-icons/faCoffee';
import { faExclamationTriangle as faExclamationTriangleSolid } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faExclamationTriangle as faExclamationTriangleLight } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faCheck as faCheckSolid } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheck as faCheckLight } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faArrowLeft as faArrowLeftSolid } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight as faArrowRightSolid } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowUp as faArrowUpSolid } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faPlayCircle as faPlayCircleSolid } from '@fortawesome/pro-solid-svg-icons/faPlayCircle';
import { faPlus as faPlusSolid } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faExclamation as faExclamationSolid } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faUser as faUserSolid } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStarHalfAlt as faStarHalfAltSolid } from '@fortawesome/pro-solid-svg-icons/faStarHalfAlt';
import { faBuilding as faBuildingSolid } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBuilding as faBuildingLight } from '@fortawesome/pro-light-svg-icons/faBuilding';
import { faSignOutAlt as faSignOutAltSolid } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faSignInAlt as faSignInAltSolid } from '@fortawesome/pro-solid-svg-icons/faSignInAlt';
import { faLock as faLockSolid } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLockOpen as faLockOpenSolid } from '@fortawesome/pro-solid-svg-icons/faLockOpen';
import { faPlay as faPlaySolid } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faVideo as faVideoSolid } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as faHomeSolid } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faShieldAlt as faShieldAltSolid } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faSpinner as faSpinnerSolid } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faFileAlt as faFileAltSolid } from '@fortawesome/pro-solid-svg-icons/faFileAlt';
import { faFileImage as faFileImageSolid } from '@fortawesome/pro-solid-svg-icons/faFileImage';
import { faFilePdf as faFilePdfSolid } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFileWord as faFileWordSolid } from '@fortawesome/pro-solid-svg-icons/faFileWord';
import { faFilePowerpoint as faFilePowerpointSolid } from '@fortawesome/pro-solid-svg-icons/faFilePowerpoint';
import { faFileExcel as faFileExcelSolid } from '@fortawesome/pro-solid-svg-icons/faFileExcel';
import { faRedo as faRedoSolid } from '@fortawesome/pro-solid-svg-icons/faRedo';
import { faDownload as faDownloadSolid } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faCalendarCheck as faCalendarCheckSolid } from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import { faCalendarPlus as faCalendarPlusSolid } from '@fortawesome/pro-solid-svg-icons/faCalendarPlus';
import { faCalendarDay as faCalendarDaySolid } from '@fortawesome/pro-solid-svg-icons/faCalendarDay';
import { faCalendarAlt as faCalendarAltSolid } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import { faLink as faLinkSolid } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faExternalLinkAlt as faExternalLinkAltSolid } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';
import { faGlobeAmericas as faGlobeAmericasSolid } from '@fortawesome/pro-solid-svg-icons/faGlobeAmericas';
import { faGlobeAsia as faGlobeAsiaSolid } from '@fortawesome/pro-solid-svg-icons/faGlobeAsia';
import { faQuestion as faQuestionSolid } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { faMinus as faMinusSolid } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faPhone as faPhoneSolid } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faHourglass as faHourglassSolid } from '@fortawesome/pro-solid-svg-icons/faHourglass';
import { faListAlt as faListAltSolid } from '@fortawesome/pro-solid-svg-icons/faListAlt';
import { faChild as faChildSolid } from '@fortawesome/pro-solid-svg-icons/faChild';
import { faMedal as faMedalSolid } from '@fortawesome/pro-solid-svg-icons/faMedal';
import { faEuroSign as faEuroSignSolid } from '@fortawesome/pro-solid-svg-icons/faEuroSign';
import { faCog as faCogSolid } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faThumbsUp as faThumbsUpSolid } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { faThumbsDown as faThumbsDownSolid } from '@fortawesome/pro-solid-svg-icons/faThumbsDown';
import { faStamp as faStampSolid } from '@fortawesome/pro-solid-svg-icons/faStamp';
import { faWifi as faWifiSolid } from '@fortawesome/pro-solid-svg-icons/faWifi';
import { faSignal as faSignalSolid } from '@fortawesome/pro-solid-svg-icons/faSignal';
import { faGlobe as faGlobeSolid } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faEye as faEyeSolid } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faQuoteLeft as faQuoteLeftSolid } from '@fortawesome/pro-solid-svg-icons/faQuoteLeft';
import { faReceipt as faReceiptSolid } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faComments as faCommentsSolid } from '@fortawesome/pro-solid-svg-icons/faComments';
import { faExpand as faExpandSolid } from '@fortawesome/pro-solid-svg-icons/faExpand';
import { faCompress as faCompressSolid } from '@fortawesome/pro-solid-svg-icons/faCompress';
import { faFolder as faFolderSolid } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { faFolderOpen as faFolderOpenSolid } from '@fortawesome/pro-solid-svg-icons/faFolderOpen';
import { faDotCircle as faDotCircleSolid } from '@fortawesome/pro-solid-svg-icons/faDotCircle';
import { faBullseye as faBullseyeSolid } from '@fortawesome/pro-solid-svg-icons/faBullseye';
import { faChevronDown as faChevronDownRegular } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp as faChevronUpRegular } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faVideoPlus as faVideoPlusLight } from '@fortawesome/pro-light-svg-icons/faVideoPlus';
import { faFile as faFileLight } from '@fortawesome/pro-light-svg-icons/faFile';
import { faListCheck as faListCheckLight } from '@fortawesome/pro-light-svg-icons/faListCheck';
import { faFileCertificate as faFileCertificateLight } from '@fortawesome/pro-light-svg-icons/faFileCertificate';
import { faStar as faStarLight } from '@fortawesome/pro-light-svg-icons/faStar';
import { faBlog as faBlogLight } from '@fortawesome/pro-light-svg-icons/faBlog';
import { faLocationDot as faLocationDotLight } from '@fortawesome/pro-light-svg-icons/faLocationDot';
import { faMobile as faMobileLight } from '@fortawesome/pro-light-svg-icons/faMobile';
import { faPaperPlaneTop as faPaperPlaneTopLight } from '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import { faBadgeCheck as faBadgeCheckLight } from '@fortawesome/pro-light-svg-icons/faBadgeCheck';
import { faLocationCheck as faLocationCheckLight } from '@fortawesome/pro-light-svg-icons/faLocationCheck';
import { faMagnifyingGlass as faMagnifyingGlassLight } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faWaveSine as faWaveSineLight } from '@fortawesome/pro-light-svg-icons/faWaveSine';
import { faWheelchair as faWheelchairLight } from '@fortawesome/pro-light-svg-icons/faWheelchair';
import { faGraduationCap as faGraduationCapLight } from '@fortawesome/pro-light-svg-icons/faGraduationCap';
import { faBriefcase as faBriefcaseLight } from '@fortawesome/pro-light-svg-icons/faBriefcase';
import { faSchool as faSchoolSolid } from '@fortawesome/pro-solid-svg-icons/faSchool';
import { faSchool as faSchoolLight } from '@fortawesome/pro-light-svg-icons/faSchool';
import { faUserVneck as faUserVneckLight } from '@fortawesome/pro-light-svg-icons/faUserVneck';
import { faFiles as faFilesLight } from '@fortawesome/pro-light-svg-icons/faFiles';
import { faCircleInfo as faCircleInfoLight } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { faHouseLaptop as faHouseLaptopLight } from '@fortawesome/pro-light-svg-icons/faHouseLaptop';
import { faPersonWalking as faPersonWalkingLight } from '@fortawesome/pro-light-svg-icons/faPersonWalking';
import { faRainbow as faRainbowLight } from '@fortawesome/pro-light-svg-icons/faRainbow';
import { faStarOfLife as faStarOfLifeLight } from '@fortawesome/pro-light-svg-icons/faStarOfLife';
import { faLink as faLinkRegular } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faChartNetwork as faChartNetworkLight } from '@fortawesome/pro-light-svg-icons/faChartNetwork';
import { faPartyHorn as faPartyHornLight } from '@fortawesome/pro-light-svg-icons/faPartyHorn';
import { faHandWave as faHandWaveLight } from '@fortawesome/pro-light-svg-icons/faHandWave';
import { faEarthAmericas as faEarthAmericasLight } from '@fortawesome/pro-light-svg-icons/faEarthAmericas';
import { faFaceFrownSlight } from '@fortawesome/pro-solid-svg-icons/faFaceFrownSlight';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons/faEllipsisVertical';
import { faComment } from '@fortawesome/pro-light-svg-icons/faComment';

export default (library: Library) => {
    library.add(faEllipsisVertical);

    library.add(faFileUserSolid);
    library.add(faFileUserRegular);
    library.add(faFileUserLight);

    library.add(faFileArrowUpSolid);

    library.add(faPenSolid);
    library.add(faPenLight);
    library.add(faTrashSolid);
    library.add(faTrashCanLight);
    library.add(faTimesSolid);
    library.add(faSearchSolid);
    library.add(faStarSolid);
    library.add(faStarHalfAltSolid);
    library.add(faBullseyeSolid);

    library.add(faCheckCircleSolid);
    library.add(faCheckCircleLight);
    library.add(faTimesCircleSolid);
    library.add(faMinusCircleSolid);
    library.add(faDotCircleSolid);

    library.add(faMapMarkerAltSolid);
    library.add(faChevronDownSolid);
    library.add(faChevronUpSolid);
    library.add(faChevronRightSolid);
    library.add(faChevronDownRegular);
    library.add(faChevronUpRegular);
    library.add(faChevronLeftSolid);
    library.add(faCaretDownSolid);
    library.add(faCaretUpSolid);
    library.add(faCaretRightSolid);
    library.add(faCaretLeftSolid);

    library.add(faThListSolid);
    library.add(faThSolid);
    library.add(faBarsSolid);
    library.add(faClipboardCheckSolid);
    library.add(faFileSolid);

    library.add(faGraduationCapSolid);
    library.add(faEnvelopeSolid);
    library.add(faCalendarSolid);
    library.add(faCalendarLight);
    library.add(faCalendarCheckSolid);
    library.add(faCalendarPlusSolid);
    library.add(faCalendarDaySolid);
    library.add(faCalendarAltSolid);

    library.add(faUserCircleSolid);
    library.add(faUserCheckSolid);
    library.add(faUserGraduateSolid);
    library.add(faUserEditSolid);
    library.add(faSignOutAltSolid);
    library.add(faSignInAltSolid);
    library.add(faFilterSolid);

    library.add(faExclamationCircleSolid);
    library.add(faExclamationCircleLight);
    library.add(faSadTearSolid);
    library.add(faClockSolid);

    library.add(faSaveSolid);
    library.add(faBriefcaseSolid);
    library.add(faBullhornSolid);
    library.add(faExclamationTriangleSolid);
    library.add(faExclamationTriangleLight);

    library.add(faCheckSolid);
    library.add(faCheckLight);
    library.add(faArrowLeftSolid);
    library.add(faArrowRightSolid);
    library.add(faArrowUpSolid);
    library.add(faPlusSolid);
    library.add(faCoffeeSolid);
    library.add(faThumbsUpSolid);
    library.add(faThumbsDownSolid);

    library.add(faExclamationSolid);
    library.add(faUserSolid);
    library.add(faBuildingSolid);
    library.add(faBuildingLight);

    library.add(faLockSolid);
    library.add(faLockOpenSolid);
    library.add(faPlayCircleSolid);
    library.add(faPlaySolid);
    library.add(faVideoSolid);

    library.add(faHeartSolid);
    library.add(faHomeSolid);
    library.add(faReceiptSolid);

    library.add(faShieldAltSolid);
    library.add(faSpinnerSolid);
    library.add(faFileAltSolid);
    library.add(faFileImageSolid);
    library.add(faFilePdfSolid);
    library.add(faFileWordSolid);
    library.add(faFilePowerpointSolid);
    library.add(faFileExcelSolid);

    library.add(faRedoSolid);
    library.add(faDownloadSolid);

    library.add(faLinkSolid);
    library.add(faExternalLinkAltSolid);

    library.add(faGlobeAmericasSolid);
    library.add(faGlobeAsiaSolid);
    library.add(faQuestionSolid);

    library.add(faMinusSolid);
    library.add(faPhoneSolid);
    library.add(faHourglassSolid);

    library.add(faListAltSolid);
    library.add(faChildSolid);
    library.add(faMedalSolid);

    library.add(faEuroSignSolid);
    library.add(faCogSolid);

    library.add(faStampSolid);
    library.add(faWifiSolid);
    library.add(faSignalSolid);
    library.add(faGlobeSolid);
    library.add(faEyeSolid);
    library.add(faFolderSolid);
    library.add(faFolderOpenSolid);
    library.add(faQuoteLeftSolid);
    library.add(faCommentsSolid);
    library.add(faExpandSolid);
    library.add(faCompressSolid);

    library.add(faSchoolSolid);

    library.add(faVideoPlusLight);
    library.add(faFileLight);
    library.add(faListCheckLight);
    library.add(faFileCertificateLight);
    library.add(faStarLight);
    library.add(faBlogLight);
    library.add(faLocationDotLight);
    library.add(faMobileLight);
    library.add(faPaperPlaneTopLight);
    library.add(faBadgeCheckLight);
    library.add(faLocationCheckLight);
    library.add(faMagnifyingGlassLight);
    library.add(faWaveSineLight);
    library.add(faWheelchairLight);
    library.add(faGraduationCapLight);
    library.add(faBriefcaseLight);
    library.add(faSchoolLight);
    library.add(faUserVneckLight);
    library.add(faFilesLight);
    library.add(faCircleInfoLight);
    library.add(faHouseLaptopLight);
    library.add(faPersonWalkingLight);
    library.add(faRainbowLight);
    library.add(faStarOfLifeLight);

    library.add(faLinkRegular);
    library.add(faChartNetworkLight);
    library.add(faPartyHornLight);
    library.add(faHandWaveLight);
    library.add(faEarthAmericasLight);

    library.add(faFaceFrownSlight);
    library.add(faComment);
};
